import { useEffect } from 'react';
import { useGallery, usePage } from 'app/hooks';
import { store } from 'app/support/searchHistory';
import useSearchQueryAdapter from 'app/adapters/shared/searchParameters/useSearchQueryAdapter';

export default () => {
  const gallery = useGallery();
  const page = usePage();
  const toSearchQuery = useSearchQueryAdapter();

  useEffect(() => {
    if (page.isInitializedOrLoaded()) {
      store(gallery, toSearchQuery);
    }
  }, [page.status]);
};
